<h2 mat-dialog-title class="bg-white  px-4">
  <span class="w-full flex items-center justify-between gap-4 pt-2">
    <span class="flex items-center gap-3 min-w-0">
      <button class="shrink-0 h-7 w-7 rounded-control inline-flex items-center justify-center text-gray-400 transition cursor-pointer hover:bg-gray-100 hover:text-gray-900" (click)="onClose.emit()">
        <i class="fas fa-times"></i>
      </button>
      <span class="truncate text-base font-semibold text-gray-900">{{title}}</span>
    </span>
    <div class="flex items-center gap-2">
      <button matRipple class="btn btn-secondary btn-sm" (click)="onShare.emit()" *ngIf="!processing && share">
        <i class="fas fa-share mr-1"></i>
        Share
      </button>
      <button class="btn btn-sm btn-ghost" (click)="onRefresh.emit()" *ngIf="!refreshing && refresh" [matTooltip]="refreshTooltip">
        Refresh
      </button>
      <button class="btn btn-sm btn-processing" *ngIf="refreshing && refresh" disabled>
        <i class="fas fa-circle-notch"></i>
        Refreshing...
      </button>
      <button class="btn btn-primary btn-sm" *ngIf="save && !processing" (click)="onSave.emit()">
        <i class="fas fa-save"></i>
        Save
      </button>
       <button class="btn btn-primary btn-sm" *ngIf="create && !processing" (click)="onCreate.emit()">
        <i class="fas fa-plus"></i>
        Create
      </button>
      <button class="btn btn-primary btn-sm" *ngIf="next && !processing" (click)="onNext.emit()">
        Next
      </button>
      <button class="btn btn-primary btn-sm" *ngIf="send && !processing" (click)="onSend.emit()">
        <i class="fas fa-paper-plane"></i>
        Send
      </button>
      <button class="btn btn-primary btn-sm" *ngIf="export && !processing" (click)="onExport.emit()">
        <i class="fas fa-file-export"></i>
        Export
      </button>
      <button class="btn btn-primary btn-sm" *ngIf="test && !processing" (click)="onTest.emit()">
        <i class="fas fa-vial"></i>
        Run test
      </button>
      <button class="btn btn-danger btn-sm" *ngIf="confirm && !processing" (click)="onConfirm.emit()">
        Confirm
      </button>
      <button class="btn btn-primary btn-sm" *ngIf="useTemplate && !processing" (click)="onUseTemplate.emit()">
        <i class="fas fa-wand-magic-sparkles"></i>
        Use template
      </button>
      <button class="btn btn-processing btn-sm" *ngIf="processing">
        <i class="fas fa-gear"></i>
        <span class="ml-1">Processing...</span>
      </button>
    </div>
  </span>
</h2>
